export const KPI_GAP = 10;

/** How many pills fit on one line of `width` (px), leaving room for a "Show more" button when some must be hidden. */
export function pillsThatFit(widths: number[], width: number, buttonWidth: number, gap = KPI_GAP): number {
    const total = widths.reduce((s, w, i) => s + w + (i ? gap : 0), 0);
    if (total <= width) return widths.length;
    let used = 0;
    for (let i = 0; i < widths.length; i++) {
        const next = used + (i ? gap : 0) + widths[i];
        if (next + gap + buttonWidth > width) return Math.max(1, i);
        used = next;
    }
    return widths.length;
}
